import {Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';

@Component({
  selector: 'tab',
  template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class TabComponent {
  @Output() public click: EventEmitter<any> = new EventEmitter();
  @Input() public active: boolean;
  @ViewChild(TemplateRef) template: TemplateRef<any>;
}
